module.exports = __webpack_public_path__ + "images/feature/new-feature-c1c166e2816238078b14b985ff2b8bba.gif";